import React, { useState, useEffect } from 'react';
import { Chart } from 'primereact/chart';
import { Accordion, AccordionTab } from 'primereact/accordion';
import ResumoIntimacoesService from '../../app/service/ResumoIntimacoesService';

import '../home/calendario.css';
import '../home/painel.css'
import './dashboard-publicacoes.css';

const DashboardPublicacoes = ({ filtro }) => {
    const [quantidades, setQuantidades] = useState({
        publicacoes: 0,
        processos: 0,
        processosNovos: 0,
        prazosCriados: 0
    });

    const [dadosGraficos, setDadosGraficos] = useState({
        grupoTrabalho: [],
        statusProcessual: [],
        areaAtuacao: [],
        tribunal: []
    });

    //Recarrega só quando uma consulta é feita (filtro aplicado), com os mesmos filtros da lista
    useEffect(() => {
        const carregarResumo = async () => {
            try {
                if (!filtro) {
                    return;
                }

                const resumoService = new ResumoIntimacoesService();

                const [resumoResp, grupoResp, statusResp, areaResp, tribunalResp] = await Promise.all([
                    resumoService.resumo(filtro),
                    resumoService.graficoGrupoTrabalho(filtro),
                    resumoService.graficoStatusProcessual(filtro),
                    resumoService.graficoAreaAtuacao(filtro),
                    resumoService.graficoTribunal(filtro)
                ]);

                const resumoData = resumoResp?.data || resumoResp || {};
                const grupoData = grupoResp?.data || grupoResp || [];
                const statusData = statusResp?.data || statusResp || [];
                const areaData = areaResp?.data || areaResp || [];
                const tribunalData = tribunalResp?.data || tribunalResp || [];

                setQuantidades({
                    publicacoes: resumoData.intimacoes || 0,
                    processos: resumoData.processos || 0,
                    processosNovos: resumoData.processosNovos || 0,
                    prazosCriados: resumoData.prazosCriados || 0
                });

                setDadosGraficos({
                    grupoTrabalho: grupoData,
                    statusProcessual: statusData,
                    areaAtuacao: areaData,
                    tribunal: tribunalData
                });
            } catch (error) {
                console.error('Erro ao carregar dashboard de publicações:', error);
            }
        };

        carregarResumo();
    }, [filtro]);

    const prepararDadosPie = (dados) => ({
        labels: dados.map(d => d.nome),
        datasets: [{
            data: dados.map(d => d.total),
            backgroundColor: dados.map(d => d.cor),
            hoverBackgroundColor: dados.map(d => d.cor)
        }]
    });

    const prepararDadosBar = (dados) => ({
        labels: dados.map(d => d.nome),
        datasets: [{
            label: 'Total',
            data: dados.map(d => d.total),
            backgroundColor: dados.map(d => d.cor),
            borderColor: dados.map(d => d.cor),
            borderWidth: 1
        }]
    });

   const optionsPie = {
			responsive: true,
			maintainAspectRatio: false, // 🔥 ESSENCIAL
			plugins: {
				legend: {
					position: 'bottom',
				}
			}
		};

    const optionsBar = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Quantidade'
            }
        },
        scales: {
            y: {
                beginAtZero: true
            }
        }
    };

    return (
        <div className="dashboard-publicacoes" style={{ width: '100%', boxSizing: 'border-box' }}>
            <Accordion activeIndex={0} style={{ width: '100%' }}>
                <AccordionTab header="Resumo de Intimações">
                    {/* Cards */}
                    <div className="cards-dashboard">
											<div className="card-dashboard azul_intimacoes">
												<span>Publicações</span>
												<h2>{quantidades.publicacoes}</h2>
											</div>

											<div className="card-dashboard verde_intimacoes">
												<span>Processos</span>
												<h2>{quantidades.processos}</h2>
											</div>

											<div className="card-dashboard amarelo_intimacoes">
												<span>Processos Novos</span>
												<h2>{quantidades.processosNovos}</h2>
											</div>

											<div className="card-dashboard vermelho_intimacoes">
												<span>Prazos Criados</span>
												<h2>{quantidades.prazosCriados}</h2>
											</div>
										</div>
                    {/* Gráficos */}
										<div className="col-md-12">
											<div className="row">
												<div className="col-md-6">
													<div class="cardMiniAgendaPainel">
														<div class="card-header-MiniAgenda">
															<span><h3>Tribunais</h3></span>
														</div>
														<div class="card-content-MiniAgenda">
															<div className="grafico-container"> 
																<Chart 
																	type="pie"
																	data={prepararDadosBar(dadosGraficos.tribunal)}
																	options={optionsPie}
																	style={{ width: '100%', height: '300px' }}
																/>
															</div>
														</div>
													</div>
												</div>
												<div className="col-md-6">
													<div class="cardMiniAgendaPainel">
														<div class="card-header-MiniAgenda">
															<span><h3>Grupos de Trabalho</h3></span>
														</div>
														<div class="card-content-MiniAgenda">
															<div className="grafico-container"> 
																<Chart 
																	type="pie"
																	data={prepararDadosPie(dadosGraficos.grupoTrabalho)}
																	options={optionsPie}
																	style={{ width: '100%', height: '300px' }}
																/>
															</div>
														</div>
													</div>
												</div>
											</div>
											<br></br>
											<div className="row">
												<div className="col-md-6">
													<div class="cardMiniAgendaPainel">
														<div class="card-header-MiniAgenda">
															<span><h3>Áreas de Atuação</h3></span>
														</div>
														<div class="card-content-MiniAgenda">
															<div className="grafico-container"> 
																<Chart 
																	type="pie"
																	data={prepararDadosBar(dadosGraficos.areaAtuacao)}
																	options={optionsPie}
																	style={{ width: '100%', height: '300px' }}
																/>
															</div>
														</div>
													</div>
												</div>
												<div className="col-md-6">
													<div class="cardMiniAgendaPainel">
														<div class="card-header-MiniAgenda">
															<span><h3>Status Processual</h3></span>
														</div>
														<div class="card-content-MiniAgenda">
															<div className="grafico-container"> 
																<Chart 
																	type="bar"
																	data={prepararDadosPie(dadosGraficos.statusProcessual)}
																	options={optionsBar}
																	style={{ width: '100%', height: '300px' }}
																/>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
                </AccordionTab>
            </Accordion>
        </div>
    );
};

export default DashboardPublicacoes;